import FormContext from "./FormStateContext";

export const FormContextProvider = ({ children, value }) => {
  return <FormContext.Provider value={value}>{children}</FormContext.Provider>;
};
